import { Box, Kbd, KbdGroup, Text } from "@salestrak/ui";
import type { Omittable } from "@salestrak/ui";

import { MODULE_HOTKEY_LEAD } from "./tiles";

/**
 * A module tile's tooltip: where it takes you, then the chord that takes you
 * there. "Go to" because these tiles NAVIGATE — the rail's actions (Invite,
 * More, search) name what they do instead.
 *
 * The chord reads as two presses, not a combination, so the keycaps are split
 * by the word "then". `G` `+` `W` would advertise a modifier that does not
 * exist here.
 */
export function ModuleTooltipBody({
  label,
  hotkey,
}: Omittable<{ label: string; hotkey?: string }>) {
  return (
    <Box align="center" direction="row" gap="xs">
      <Text size="xs">{`Go to ${label}`}</Text>
      {hotkey != null && (
        <KbdGroup>
          <Kbd>{MODULE_HOTKEY_LEAD}</Kbd>
          <Text size="2xs" variant="muted">
            then
          </Text>
          <Kbd>{hotkey}</Kbd>
        </KbdGroup>
      )}
    </Box>
  );
}
